import { render, staticRenderFns } from "./TimeEr1.vue?vue&type=template&id=90613494&scoped=true"
import script from "./TimeEr1.vue?vue&type=script&lang=js"
export * from "./TimeEr1.vue?vue&type=script&lang=js"
import style0 from "./TimeEr1.vue?vue&type=style&index=0&id=90613494&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90613494",
  null
  
)

export default component.exports